import React from "react";
import Navbar from "./Navbar";
import HeroSection from "./Herosection";

const HeroNavbar = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
    </div>
  );
};

export default HeroNavbar;
